import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-4xl font-bold p-2"
}
const _hoisted_2 = {
  key: 1,
  class: "last-week-header"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl p-1 font-bold" }, "What people read last week", -1)
const _hoisted_4 = {
  key: 0,
  class: "text-lg p-1"
}
const _hoisted_5 = { class: "blogs-wrapper px-4" }
const _hoisted_6 = {
  key: 0,
  class: "blogs-container"
}
const _hoisted_7 = {
  key: 0,
  class: "blogs-by-user-container"
}
const _hoisted_8 = { class: "blog-owner" }
const _hoisted_9 = { class: "owner_name text-lg" }
const _hoisted_10 = { class: "mx-2 text-2xl" }
const _hoisted_11 = { class: "blog-item my-1" }
const _hoisted_12 = { class: "blog_title text-2xl hover:underline" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "publisher" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Load more", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "no-data-found" }, "No blogs found", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 0,
  class: "loading-div"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "helper" }, null, -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      (!_ctx.isLastWeekActive)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "What people are reading this week"))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.startOfWeek && _ctx.endOfWeek)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_4, " (" + _toDisplayString(_ctx.startOfWeek) + " to " + _toDisplayString(_ctx.endOfWeek) + ") ", 1))
              : _createCommentVNode("", true)
          ])),
      (!_ctx.isLastWeekActive)
        ? (_openBlock(), _createElementBlock("h3", {
            key: 2,
            class: "load-last-week cursor-pointer linkable font-bold p-1 text-lg hover:underline",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadlastWeekBlogs && _ctx.loadlastWeekBlogs(...args)))
          }, "View last week's articles"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_5, [
      (_ctx.blogsFound)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "blogs-by-user",
                key: user.id
              }, [
                (_ctx.userBlogs[user.user_id] && _ctx.userBlogs[user.user_id].length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(user.name), 1),
                        _createTextVNode(" recommended articles ")
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userBlogs[user.user_id], (blog) => {
                        return (_openBlock(), _createElementBlock("ul", {
                          class: "blog-list px-3 list-disc",
                          key: blog.id
                        }, [
                          _createElementVNode("li", _hoisted_10, [
                            _createElementVNode("article", _hoisted_11, [
                              _createElementVNode("h1", _hoisted_12, [
                                _createElementVNode("a", {
                                  href: blog.url,
                                  target: "_blank",
                                  class: "blog_link cursor-pointer"
                                }, _toDisplayString(blog.header), 9, _hoisted_13),
                                _createElementVNode("span", _hoisted_14, " (" + _toDisplayString(blog.publisher) + ")", 1)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (!_ctx.allBlogsLoaded)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "loadmore",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadmore && _ctx.loadmore(...args)))
                }, _hoisted_16))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23))
      : _createCommentVNode("", true)
  ], 64))
}